import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

export default function useHistory(ticker, tf = "1D") {
  const [points, setPoints] = useState([]);
  useEffect(() => {
    if (!ticker) return;
    let stop = false;
    async function load() {
      try {
        const { data } = await axios.get(`${API}/history/${ticker}?tf=${tf}`, { timeout: 8000 });
        if (stop) return;
        setPoints(data.points || []);
      } catch (e) {
        // keep empty
      }
    }
    load();
    const id = setInterval(load, 15_000);
    return () => { stop = true; clearInterval(id); };
  }, [ticker, tf]);
  return points;
}
